import { ReactComponent as SvgLock } from '@img/icons/padlock-unbranded.svg';
import React from 'react';
import S from './Select.styles';
const Select = React.forwardRef(({ children, className, readOnly = false, multiple = false, ...otherProps }, ref) => {
    return (React.createElement(S.Container, { className: className },
        React.createElement(S.Select, { ref: ref, ...otherProps, disabled: readOnly, multiple: multiple }, children),
        readOnly && React.createElement(S.Icon, { as: SvgLock, "aria-hidden": true })));
});
Select.displayName = 'Select';
export default Select;
